// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3615": "995efd144f0e","6046": "9e6d8f2d757b","6863": "454c9f289029","8357": "dd422574e14d","8481": "0d9b0ffb81b2",}[chunkId] + ".css"
}